import axios from 'axios'
import { Notification, MessageBox, Message } from 'element-ui'
// import store from '@/store'
import Cookies from 'js-cookie'
import { getToken, setToken } from '@/utils/auth'

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
axios.defaults.withCredentials = true;// 用于跨域处理

export function request (config) {
  // 创建axios实例
  const instance = axios.create({
    // axios中请求配置有baseURL选项，表示请求URL公共部分
    baseURL: '/prod-api',
    // 超时
    timeout: 20000
  });
  // request拦截器
  instance.interceptors.request.use(
    config => {
      if (getToken()) {
        config.headers['Authorization'] = 'Bearer ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
      }
      return config
    },
    error => {
      console.log(error)
      Promise.reject(error)
    }
  );

  // 响应拦截器
  instance.interceptors.response.use(res => {
    const code = res.data.code

    if (code === 401) {

      if(Cookies.get('typein')==1){
          Cookies.set('typein',2);
        }else{

           MessageBox.confirm(
        '登录状态已过期，您可以继续留在该页面，或者重新登录',
        '系统提示',
        {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(() => {
        window.location.href=('http://'+window.location.host+'/login');
      })
        }
     return res
     /* */
    }else {
      return res
    }
  },
    error => {
      console.log('err' + error)
      Message({
        message: error.message,
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(error)
    }
  );
  // 发送网络请求
  return instance(config)
}


// 简写:
// import axios from 'axios'

// export function request (config) {
//   return new Promise((resolve, reject) => {
//     创建axios实例
//     const instance = axios.create({
//       baseURL: '',
//     })
//     // 发送网络请求
//     instance(config).then(res => {
//       resolve(res)
//     }).catch(err => {
//       reject(err)
//     })
//   })
// }


/*
import axios from 'axios'
import { Notification, MessageBox, Message } from 'element-ui'
import store from '@/store'
import { getToken, setToken } from '@/utils/auth'

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
axios.defaults.withCredentials = true;// 用于跨域处理

export const request=function(config) {
  // 创建axios实例
  // 创建axios实例
  const service = axios.create({
    // axios中请求配置有baseURL选项，表示请求URL公共部分
    baseURL: 'http://bgm.jrdsj.com',
    // 超时
    timeout: 10000
  })

// request拦截器
  service.interceptors.request.use(
    config => {
      if (getToken()) {
        config.headers['Authorization'] = 'Bearer ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
      }
      if (tokens != "") {
        config.headers['Authorization'] = 'Bearer ' + tokens // 让每个请求携带自定义token 请根据实际情况自行修改
      }
      return config
    },
    error => {
      console.log(error)
      Promise.reject(error)
    }
  )

// 响应拦截器
  service.interceptors.response.use(res => {
      const code = res.data.code
      if (code === 401) {
        MessageBox.confirm(
          '登录状态已过期，您可以继续留在该页面，或者重新登录',
          '系统提示',
          {
            confirmButtonText: '重新登录',
            cancelButtonText: '取消',
            type: 'warning'
          }
        ).then(() => {
          store.dispatch('LogOut').then(() => {
            location.reload() // 为了重新实例化vue-router对象 避免bug
          })
        })
      } else if (code !== 200) {
        Notification.error({
          title: res.data.msg
        })
        return Promise.reject('error')
      } else {
        return res.data
      }
    },
    error => {
      console.log('err' + error)
      Message({
        message: error.message,
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(error)
    }
  )
  return service(config)
}

*/





// WEBPACK FOOTER //
// ./src/network/request.js